// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2AGbR","col":"styles_col__19K49"};